import React from 'react';

import DesktopMenu from './blocks/DesktopMenu';
import DesktopHeader from './blocks/DesktopHeader';

import MobileMenu from './blocks/MobileMenu';
import MobileHeader from './blocks/MobileHeader';

import { Sticky } from 'react-sticky';

import withSizes from 'react-sizes';

const MENU_ITEMS = [
  {
    title: 'Главная',
    key: 'index',
    link: '/',
  },
  {
    title: 'Глаз не отвести',
    key: 'architecture',
    link: '/architecture',
  },
  {
    title: 'Гений места',
    key: 'architecture2',
    link: '/genious',
  },
  {
    title: 'Стремление вверх',
    key: 'matchpoint',
    link: '/matchpoint',
  },
  {
    title: 'Проект красит место',
    key: 'place',
    link: '/place',
  },
];

const TITLE = 'Движение большой Москвы';

const DESCRIPTION =
  'У российской столицы, как практически у каждого мегаполиса, есть свой генетический код, заложенный в архитектуру города, в ее исторический облик.  Его нельзя никак изменить, даже несмотря на то, что за время своего существования Москва несколько раз проходила серьезные трансформации — из купеческой обители она превратилась в современный центр страны. Нынешним девелопером приходится с этим считаться: они стараются подойти к городской среде со всей деликатностью.';

class Menu extends React.Component {
  render() {
    const { isMobile, showHeader, headerHeight } = this.props;

    if (isMobile) {
      return (
        <div>
          <Sticky>
            {({ style }) => (
              <div style={{ ...style, zIndex: 10 }}>
                <MobileMenu items={MENU_ITEMS} {...this.props} />
              </div>
            )}
          </Sticky>
          {showHeader && (
            <MobileHeader title={TITLE} description={DESCRIPTION} />
          )}
        </div>
      );
    }

    return (
      <div>
        {showHeader && (
          <DesktopHeader title={TITLE} description={DESCRIPTION} />
        )}
        <Sticky topOffset={showHeader ? headerHeight : 0}>
          {({ style }) => (
            <div style={{ ...style, zIndex: 10 }}>
              <DesktopMenu items={MENU_ITEMS} {...this.props} />
            </div>
          )}
        </Sticky>
      </div>
    );
  }
}

const mapSizesToProps = ({ width, height }) => ({
  isMobile: width < 900,
  headerHeight: height,
});

export default withSizes(mapSizesToProps)(Menu);
